import {
  GET_TILLS, GET_TILLS_COMPLETED, GET_TILLS_FAILED,
  GET_TILL, GET_TILL_COMPLETED, GET_TILL_FAILED,
  ADD_TILL, ADD_TILL_COMPLETED, ADD_TILL_FAILED,
  UPDATE_TILL, UPDATE_TILL_COMPLETED, UPDATE_TILL_FAILED,
  SEARCH_TILLS, SEARCH_TILLS_COMPLETED, SEARCH_TILLS_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  gettingTills: false,
  tills: [],
  getTillsError: null,
  gettingTill: false,
  till: null,
  getTillError: null,
  addingTill: false,
  addTillError: null,
  updatingTill: false,
  updateTillError: null,
  search: searchDefault,
};

const tillReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_TILLS: return handleSearch(state, 'search', action.payload);
    case SEARCH_TILLS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_TILLS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_TILLS: {
      return {
        ...state,
        gettingTills: true,
        tills: [],
        getTillsError: null,
      };
    }
    case GET_TILLS_COMPLETED: {
      return {
        ...state,
        gettingTills: false,
        tills: action.payload.data,
      };
    }
    case GET_TILLS_FAILED: {
      return {
        ...state,
        gettingTills: false,
        getTillsError: action.payload,
      };
    }
    case GET_TILL: {
      return {
        ...state,
        gettingTill: true,
        till: null,
        getTillError: null,
      };
    }
    case GET_TILL_COMPLETED: {
      return {
        ...state,
        gettingTill: false,
        till: action.payload,
      };
    }
    case GET_TILL_FAILED: {
      return {
        ...state,
        gettingTill: false,
        getTillError: action.payload,
      };
    }
    case ADD_TILL: {
      return {
        ...state,
        addingTill: true,
        addTillError: null,
      };
    }
    case ADD_TILL_COMPLETED: {
      return {
        ...state,
        addingTill: false,
      };
    }
    case ADD_TILL_FAILED: {
      return {
        ...state,
        addingTill: false,
        addTillError: action.payload,
      };
    }
    case UPDATE_TILL: {
      return {
        ...state,
        updatingTill: true,
        updateTillError: null,
      };
    }
    case UPDATE_TILL_COMPLETED: {
      return {
        ...state,
        updatingTill: false,
      };
    }
    case UPDATE_TILL_FAILED: {
      return {
        ...state,
        updatingTill: false,
        updateTillError: action.payload,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default tillReducer;



// WEBPACK FOOTER //
// ./src/Till/reducer.js